import {
  Box,
  Button,
  Flex,
  Image,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  UseDisclosureProps,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BaseUrl, EMonthsTicket } from "../../../const.ts";
import { ITickets } from "../../../model.ts";
import { TabPanelTicket } from "./tabPanelTicket.tsx";

interface IProps {
  tickets: ITickets;
  onClose: UseDisclosureProps["onClose"];
  loading: boolean;
  onSubmit: (x: any) => void;
}

export const CheckTickets = ({
  tickets,
  onClose,
  loading,
  onSubmit,
}: IProps) => {
  const { t } = useTranslation();
  const { handleSubmit, watch } = useFormContext();
  const getName = (index, i) =>
    `eventTicketInfo.${index}.ticketInfo.${i}.quantity`;

  const calculateTotalPrice = () => {
    return tickets?.eventTicketInfoList.reduce((total, item, index) =>
            total +
            item.ticketInfo.reduce((sum, it, i) => {
              const quantity = parseInt(watch(getName(index, i))) || 0;
              const limitedQuantity =
                  it.limitPerUser === 0 ? quantity : Math.min(quantity, it.limitPerUser);
              return sum + it.price * limitedQuantity;
            }, 0)
        , 0);
  };


  const checkIsTicket = watch("eventTicketInfo")?.find((item) =>
    item.ticketInfo.some((item) => item.quantity > 0)
  );

  return (
      <>
        <ModalHeader>{t("get_tickets")}</ModalHeader>
        {tickets?.placeImageUrl && (
            <Image
                src={`${BaseUrl}/images/${tickets.placeImageUrl}`}
                alt="Venue Image"
                w="100%"
                h="200px"
                objectFit="cover"
            />
        )}
        <ModalBody>
          <Tabs maxH="400px" overflow="auto">
            <TabList w="100%" overflow="auto">
              {tickets?.eventTicketInfoList.map((item) => (
                  <Tab key={item.startDate}>
                    <VStack alignItems="center">
                      <Text>{EMonthsTicket[item.startDate.split("-")[1]]}</Text>
                      <Text>{item.startDate.split("-")[2]}</Text>
                    </VStack>
                  </Tab>
              ))}
            </TabList>

            <TabPanels>
              {tickets?.eventTicketInfoList.map((item, index) => (
                  <TabPanel key={item.startDate}>
                    <TabPanelTicket item={item.ticketInfo} index={index} />
                  </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </ModalBody>
        <ModalFooter>
          <Flex justify="space-between" w="100%">
            <Text fontWeight="bold">
              {t("total")}:{" "}
              {isNaN(calculateTotalPrice()) ? 0 : calculateTotalPrice()} &#8380;
            </Text>
            <Box>
              <Button onClick={onClose} colorScheme="red" mr={3}>
                {t("Close")}
              </Button>
              <Button
                  isLoading={loading}
                  colorScheme="blue"
                  isDisabled={!checkIsTicket}
                  onClick={handleSubmit(onSubmit)}
              >
                {t("buy-tickets")}
              </Button>
            </Box>
          </Flex>
        </ModalFooter>
      </>
  );
};
